import { Action, createReducer, on } from '@ngrx/store';
import { ItemsPagination } from 'src/app/model/api/data-rest';
import { Ticket } from 'src/app/model/ticket';

import * as TicketActions from 'src/app/store/ticket/ticket.actions';


export interface State {
    ticketsLoading: boolean;
    paging?: ItemsPagination;
    tickets: Ticket[];
    selectedTicket?: Ticket;
    addSuccess: boolean;
    closeSuccess: boolean;
    allTickets: Ticket[];
}

export const initialState: State = {
    ticketsLoading: false,
    tickets: [],
    addSuccess: false,
    closeSuccess: false,
    allTickets: [],
};

const siteReducer = createReducer(
    initialState,
    on(TicketActions.getTickets, (state) => ({ ...state, ticketsLoading: true })),
    on(TicketActions.getTicketsSuccess, (state, payload) => ({
        ...state,
        tickets: payload.tickets,
        paging: payload.paging,
        ticketsLoading: false
    })),
    on(TicketActions.getTicketsFailed, (state, payload) => ({ ...state, ticketsLoading: false })),
    on(TicketActions.getTicketSuccess, (state, payload) => ({ ...state, selectedTicket: payload.ticket })),
    on(TicketActions.startCloseTicket, (state) => ({ ...state, closeSuccess: false })),
    on(TicketActions.closeTicketSuccess, (state) => ({ ...state, closeSuccess: true })),
    on(TicketActions.startAddTicket, (state) => ({ ...state, addSuccess: false })),
    on(TicketActions.addTicketSuccess, (state) => ({ ...state, addSuccess: true })),
    on(TicketActions.getAllTicketsSuccess, (state, payload) => ({ ...state, allTickets: payload.tickets })),
);

export const reducer = (state: State | undefined, action: Action): State => siteReducer(state, action);

